module.exports = __webpack_public_path__ + "static/media/fund.815be60d.png";